import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { fa } from 'vuetify/iconsets/fa'

export default createVuetify({
    icons: {
        defaultSet: 'fa',
        sets: { fa }
    }
})
